import { OutboundProxy } from "callable-data-objects";
import { useVoiceRegion } from "Hooks/Endpoints";
import React from "react";
import { Button, Checkbox, Table } from "semantic-ui-react";

const OutboundProxyTable = () => {
  const { voiceRegion, selectOutboundProxy } = useVoiceRegion();

  return (
    <Table celled padded stackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell singleLine>ID</Table.HeaderCell>
          <Table.HeaderCell singleLine>IP</Table.HeaderCell>
          <Table.HeaderCell singleLine>Port</Table.HeaderCell>
          <Table.HeaderCell singleLine>Description</Table.HeaderCell>
          <Table.HeaderCell singleLine>Type</Table.HeaderCell>
          <Table.HeaderCell singleLine>Zone</Table.HeaderCell>
          <Table.HeaderCell singleLine>Priority</Table.HeaderCell>
          <Table.HeaderCell singleLine>Inbound</Table.HeaderCell>
          <Table.HeaderCell singleLine>Outbound</Table.HeaderCell>
          <Table.HeaderCell singleLine>Active</Table.HeaderCell>
          <Table.HeaderCell singleLine>Country Code</Table.HeaderCell>
          <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {voiceRegion.proxies.map((proxy: OutboundProxy) => (
          <Table.Row key={`tr-ddi-${proxy.id}`}>
            <Table.Cell singleLine>{proxy.id}</Table.Cell>
            <Table.Cell singleLine>{proxy.ip}</Table.Cell>
            <Table.Cell singleLine>{proxy.port}</Table.Cell>
            <Table.Cell singleLine>{proxy.description}</Table.Cell>
            <Table.Cell singleLine>{proxy.type}</Table.Cell>
            <Table.Cell singleLine>{proxy.zone}</Table.Cell>
            <Table.Cell singleLine>{proxy.priority}</Table.Cell>
            <Table.Cell singleLine>
              <Checkbox toggle checked={proxy.inbound} />
            </Table.Cell>
            <Table.Cell singleLine>
              <Checkbox toggle checked={proxy.outbound} />
            </Table.Cell>
            <Table.Cell singleLine>
              <Checkbox toggle checked={proxy.active} />
            </Table.Cell>
            <Table.Cell singleLine>{proxy.countryCode}</Table.Cell>
            <Table.Cell textAlign='left'>
              <Button
                primary
                size='tiny'
                onClick={() => selectOutboundProxy(proxy.id)}
              >
                Select
              </Button>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default OutboundProxyTable;
